<template>
	<div class="form-group row no-gutters nk-form-group-col" @focus="onFocus">
		<div :class="labelSizeClass" v-if="hasLabel">
			<label :class="{ 'emphasize': emphasize, 'clickable-link': onLabelClick }" @click="onClickLabel" v-html="label"></label>
			<nk-popper class="mx-1" v-if="popover" :options="popoverData.options">
				{{ popoverData.content }}
			</nk-popper>
		</div>
		<div :class="dataSizeClass">
			<div class="" ref="element">
				<slot></slot>
			</div>
			<div class="nhint" v-if="hasHint">
				<slot name="hint"></slot>
			</div>
		</div>
	</div>
</template>
<script>
	import $ from 'jquery'
	import isString from 'lodash/isString'

	export default {
		name: 'form-group-col',
		props: {
			label: { type: String },
			emphasize: { type: Boolean, required: false, default: false },
			disabled: { type: Boolean, required: false, default: false },
			labelSizes: { type: Object },
			labelAligns: { type: Object },
			dataSizes: { type: Object },
			popover: { type: [String, Object], },
			onLabelClick: { type: Function, required: false, default: null }
		},
		watch: {
			disabled: {
				handler(value, oldValue) {
					const disabledAttr = document.createAttribute('disabled')
					disabledAttr.value = true

					Array.from(this.$refs.element.children).forEach(el => {
						if (value) {
							el.attributes.setNamedItem(disabledAttr)
						} else if (el.attributes.getNamedItem('disabled') != null) {
							el.attributes.removeNamedItem('disabled')
						}
					})
				}
			}
		},
		computed: {
			popoverData() {
				if (isString(this.popover)) {
					return {
						content: this.popover,
						options: {}
					}
				}
				return this.popover
			},
			hasHint() {
				return !!this.$slots['hint']
			},
			hasLabel() {
				return (this.label && this.label.length)
			},
			labelSizeClass() {
				var classes = ['pl-2 pt-1']
				let sizes = this.labelSizes || { xs: 12 }

				for (var item in sizes) {
					if (sizes[item] === 'grow') {
						classes.push('col')
					}

					else {
						classes.push(`col-${item}-${sizes[item]}`)
						if (item === 'xs')
							classes.push(`col-${sizes.xs}`)
					}
				}

				if (classes.length === 2)
					classes.push('col-12')

				var aligns = { xs: 'right', sm: 'left', md: 'left', lg: 'left' }
				Object.assign(aligns, this.labelAligns)
				for (var item in aligns) {
					classes.push(`text-${item}-${aligns[item]}`)
				}

				return classes
			},
			dataSizeClass() {
				var classes = []
				let sizes = this.dataSizes || { xs: 12 }

				for (var item in sizes) {
					if (sizes[item] === 'grow') {
						classes.push('col')
					}

					else {
						classes.push(`col-${item}-${sizes[item]}`)
						if (item === 'xs')
							classes.push(`col-${sizes.xs}`)
					}
				}

				if (classes.length === 1)
					classes.push('col-12')

				return classes
			}
		},
		methods: {
			onFocus() {
				$(this.$refs.element).children().focus()
			},
			onClickLabel() {
				if (this.onLabelClick && typeof this.onLabelClick === 'function') {
					this.onLabelClick()
				} else {
					let els = $(this.$refs.element).children('.nikan-input, .nk-dropdown, .nikan-datetime-wrapper, .nk-ckeckbox, textarea')
					els.focus()
				}
			}
		}
	}
</script>
<style scoped>
	.form-group {
		margin-bottom: 0.5rem;
	}

	.clickable-link {
		cursor: pointer;
		color: #007bff;
		border-bottom: 1px dashed;
	}
</style>
